import { render, staticRenderFns } from "./TransferButtonAndModal.vue?vue&type=template&id=4386b03e&"
import script from "./TransferButtonAndModal.vue?vue&type=script&lang=js&"
export * from "./TransferButtonAndModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports